import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ZipCodeResponse } from '../../shared/models/zip-code.model';
import { ZipCodeService } from '../../shared/services/zip-code.service';

@Injectable({
  providedIn: 'root',
})
export class GetZipCodeResolver implements Resolve<ZipCodeResponse[]> {
  constructor(private zipCodeService: ZipCodeService) {}

  resolve(): Observable<ZipCodeResponse[]> {
    return this.zipCodeService.getAll();
  }
}
